import http from '../services/http';

/**
 * 活动

 */
export default class qiyuService {
  constructor($http) {
    this.$http = $http;
  }
  getClueList(userId) {
    return http.post('h5/sales_leads_brief_query', { user_id: userId });
  }
}
